import useAppContext from 'flow/hooks/useAppContext';
import React from 'react';

interface Props {
    title: string;
    subtitle: string;
    children?: React.ReactNode;
}

const TitleAndSubtitle = ({ title, subtitle, children }: Props) => {
    const { i18next } = useAppContext();

    //Test call is when testing audio in the app
    const isTestCall = ['0102098693', '46102098693', '0046102098693'].includes(
        title.replace(/\D/g, ''),
    );

    return (
        <div className="mx-3 flex flex-col items-center justify-center gap-1.5">
            <div
                className="overflow-hidden text-center text-ellipsis whitespace-nowrap text-white"
                data-test-id="title-subtitle-first-row"
            >
                {isTestCall ? i18next.t('call-canvas.title.test-call') : title}
            </div>

            {isTestCall ? null : (
                <div
                    className="text-sm/4 text-gray-400"
                    data-test-id="title-subtitle-second-row"
                >
                    {subtitle}
                </div>
            )}

            {children}
        </div>
    );
};

export default React.memo(TitleAndSubtitle);
